import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import NotificationPopup from '../NotificationPopup';

interface SessionExpiredPopupProps {
	isDisplayed: boolean;
	dispatch: Dispatch<StoreState>;
}

const SessionExpiredPopup = ({ isDisplayed, dispatch }: SessionExpiredPopupProps) => (
	<NotificationPopup
		isDisplayed={isDisplayed}
		dispatch={dispatch}
	>
		<Translate value="error.session_expired" />
	</NotificationPopup>
);

export default SessionExpiredPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/SessionExpiredPopup/index.tsx